import React, { Component } from 'react';
import { Link } from 'react-router';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { formatNumber, checkHttpStatus, parseJSON } from '../../../utils';
import Loader from '../../Loader';

class AllMemberSnapshots extends Component {
  constructor(props) {
    super(props);
    this.state = { snapshots: null };
    this.fetchSnapshotResults = this.fetchSnapshotResults.bind(this);
  }

  componentWillMount() {
    this.fetchSnapshotResults();
  }

  fetchSnapshotResults() {
    fetch(`${SERVER_URL}/get_all_user_snapshots.json?username=${encodeURIComponent(this.props.username)}`, {
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        this.setState({ snapshots: response.data.snapshots });
      });
  }

  render() {
    const { snapshots } = this.state;
    const { scrollPosition } = this.props;
    const loaderProps = { style: { height: 144 }, dark: true };
    return (
      <div className="row no-gutters" style={{ minHeight: 200 }}>
        {!snapshots && (<div className="col-12 position-relative" style={{height: 200}} > <Loader ref="loader" {...loaderProps} fill /></div>
          )}
          {!!snapshots && snapshots.map(function(snapshot, index){
            let currentViewers = (snapshot.current_viewers === 0 || !snapshot.current_viewers) ? ' no-viewers ' : '';
            let snapshotText = (snapshot.live) ? 'watch snapshot': 'watch highlight';

            return (
              <div className="col-3 p-1" key={snapshot.id}>
                <div className={"favorite-snapshot-item" }>
                  <Link to={snapshot.snapshots_url} target="_blank" className="snapshot-result">
                    <div className="snapshot-inner-wrap">
                      <div className="snapshot-hover-info"><div className="u-font-foundation-light abs-center hover-text">View <br />Snapshot</div></div>
                      <LazyLoadImage
                        alt={'test'}
                        height={144}
                        src={snapshot.thumbnail_url.replace('http://', 'https://')} // use normal <img> attributes as props
                        placeholder={<Loader ref="loader" {...loaderProps} fill />}
                        scrollPosition={scrollPosition}
                      />
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
      </div>
    );
  }
}

export default AllMemberSnapshots;